module.exports = __webpack_public_path__ + "img/Santander Bank Polska.9bb0b4e4.png";